module.exports = __webpack_public_path__ + "static/media/black_panther_01.8d230ae6.png";